import React from 'react';
import { Typography } from '@ann/web-components';
import {
  DocumentListContainer,
  DocumentListContent,
  BreadcrumbText,
  EmptyState,
} from './DriveDocumentList.styled';
import DocumentCard from '../../../DocumentCard';

const DriveDocumentList = ({ documents, searchTerm, driveName }) => {
  if (documents.length === 0) {
    return (
      <EmptyState>
        <Typography category="body" size="medium" color="body">
          {searchTerm
            ? `No documents found for "${searchTerm}"`
            : 'No documents in this drive'}
        </Typography>
      </EmptyState>
    );
  }

  return (
    <DocumentListContainer>
      <BreadcrumbText>
        <Typography category="body" size="medium" weight="regular" color="subtitle">
          Drive / {driveName || 'Unnamed Drive'}
        </Typography>
      </BreadcrumbText>

      {searchTerm && (
        <Typography category="body" size="small" weight="regular" color="body" style={{ marginBottom: '16px' }}>
          {documents.length} document{documents.length !== 1 ? 's' : ''} found for "{searchTerm}"
        </Typography>
      )}

      <DocumentListContent>
        {documents.map((document) => (
          <DocumentCard
            key={document.uuid || document.id}
            document={document}
            onClick={() => {}} // No action on click in drive detail
          />
        ))}
      </DocumentListContent>
    </DocumentListContainer>
  );
};

export default DriveDocumentList;

